import React, { createContext, useContext, useState, useEffect } from 'react';
import { supabase, PROBYTY_WEBSITE_ID } from '../config/supabase';

// Create context
const AppContext = createContext();

// Provider component
export const AppProvider = ({ children }) => {
  const [settings, setSettings] = useState({});

  const [loading, setLoading] = useState(true);

  // Načíst nastavení při prvním načtení
  useEffect(() => {
    loadSettings();

  }, []);

  const loadSettings = async () => {
    try {

      const { data, error } = await supabase
        .from('site_settings')
        .select('*')
        .eq('website_id', PROBYTY_WEBSITE_ID);



      if (error) throw error;

      // Převést na objekt
      const settingsObj = {};
      (data || []).forEach(item => {
        settingsObj[item.setting_key] = item.setting_value;
      });


      setSettings(settingsObj);
    } catch (err) {
      console.error('Failed to load settings:', err);
      // Použít default hodnoty
      setSettings({
        site_title: 'PRO-BYTY.cz',
        site_description: 'Váš partner pro rekonstrukce a reality',
        contact_phone: '+420 123 456 789',
        contact_email: 'info@pro-byty.cz',
        contact_address: 'Praha, Česká republika'
      });
    } finally {
      setLoading(false);
    }
  };



  // Helper pro získání aktuálního roku pro copyright
  const currentYear = new Date().getFullYear();

  const value = {
    settings,

    loading,

    currentYear,
    reloadSettings: loadSettings,

  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

// Custom hook pro použití contextu
export const useApp = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useApp must be used within AppProvider');
  }
  return context;
};